






































































































































































































import { defineComponent, PropType } from '~/utils/nuxt3-migration'
import LoanPerk from '~/components/car/classifieds/view/partials/loans/perks/LoanPerk.vue'
import { OnlineLoanType } from '~/constants/loan/loans'
import { defineComponentTranslations } from '~/utils/i18n'
import { useI18n } from '~/compositions/i18n'
import { useBlackFriday } from '~/compositions/black-friday'
import { TBI_BLACK_FRIDAY_INTEREST } from '~/constants/loan/tbi'
import {
  ALPHA_DEFAULT_CONTRIBUTION,
  ALPHA_DEFAULT_INTEREST,
  ALPHA_MAX_LOAN_AMOUNT,
  ALPHA_SALARIED_INTEREST
} from '~/constants/loan/alpha'
import { formatNumber } from '~/utils/number'

export default defineComponent({
  props: {
    loanType: {
      type: String as PropType<OnlineLoanType>,
      required: false,
      default: OnlineLoanType.AUTO
    }
  },
  components: { LoanPerk },
  setup() {
    const { isWithinTbiBlackFridayPeriod } = useBlackFriday()
    const { t } = useI18n()
    const isBlackFriday = isWithinTbiBlackFridayPeriod()
    return {
      OnlineLoanType,
      isBlackFriday,
      t,
      TBI_BLACK_FRIDAY_INTEREST,
      formatNumber,
      ALPHA_MAX_LOAN_AMOUNT,
      ALPHA_SALARIED_INTEREST,
      ALPHA_DEFAULT_CONTRIBUTION,
      ALPHA_DEFAULT_INTEREST
    }
  },
  i18n: defineComponentTranslations({
    'amount up to {amount} you can use for any purchase': {
      en: 'Amount up to {amount} you can use for any purchase',
      el: 'Προσωπικό δάνειο έως {amount} για να κάνεις όποια αγορά θέλεις'
    },
    'money to {account} in any bank rapidly': {
      en: 'Money to {account} in any bank rapidly',
      el: 'Κατάθεση χρημάτων άμεσα στον {account}'
    },
    'your bank account::loans': {
      en: 'Your bank account',
      el: 'Ελληνικό τραπεζικό σου λογαριασμό'
    },
    'quick and {process} no need to visit the bank': {
      en: 'Quick and {process} no need to visit the bank',
      el: 'Εύκολη και {process} χωρίς επίσκεψη σε φυσικό κατάστημα'
    },
    '100% online process': {
      en: '100% online process',
      el: '100% online διαδικασία'
    },
    'advantageous interest {amount}': {
      en: 'Advantageous interest {amount}',
      el: 'Σταθερό επιτόκιο {amount}'
    },
    'no hidden fees': {
      en: 'No hidden fees',
      el: 'Χωρίς εγγύηση και κρυφές χρεώσεις'
    },
    loan_perks_without_management_fees: {
      en: 'Without {amount}€ value management fees',
      el: 'Χωρίς έξοδα διαχείρισης αξίας {amount}€'
    },
    'personal loan up to {amount}': {
      en: 'Personal loan up to {amount}',
      el: 'Προσωπικό δάνειο μέχρι {amount}'
    },
    'deposit of funds to your {account}': {
      en: 'Deposit of funds to your {account}',
      el: 'Κατάθεση χρημάτων στον {account} σου'
    },
    'greek bank account::loans': {
      en: 'Greek bank account',
      el: 'Ελληνικό τραπεζικό λογαριασμό'
    },
    'you get the financing and then {veh}': {
      en: 'You get the financing and then {veh}',
      el: 'Παίρνεις την χρηματοδότηση και μετά {veh}'
    },
    'you buy any vehicle you want': {
      en: 'You buy any vehicle you want',
      el: 'Αγοράζεις όποιο όχημα θέλεις'
    },
    'fixed interest rate from {amount}': {
      en: 'Fixed interest rate from {amount}',
      el: 'Σταθερό επιτόκιο από {amount}'
    },
    'no down payment and {guar}': {
      en: 'No down payment and {guar}',
      el: 'Χωρίς προκαταβολή και {guar}'
    },
    'no guarantee needed': {
      en: 'No guarantee needed',
      el: 'Χωρίς εγγύηση'
    },
    santander_perk_1: {
      en: '{bold} application process',
      el: '{bold} διαδικασία αίτησης'
    },
    santander_perk_1_bold: {
      en: 'Fast & easy',
      el: 'Γρήγορη & εύκολη'
    },
    santander_perk_2: {
      en: '{bold} response to your email',
      el: '{bold} απάντηση στο email'
    },
    santander_perk_2_bold: {
      en: 'Immediate',
      el: 'Γρήγορη'
    },
    santander_perk_3: {
      en: '{bold} to the dealer by Santander',
      el: '{bold} του Εμπόρου από τη Santander'
    },
    santander_perk_3_bold: {
      en: 'Direct payment',
      el: 'Απευθείας εξόφληση'
    },
    santander_perk_4: {
      en: '{bold} prime interest rate',
      el: '{bold} προνομιακό επιτόκιο'
    },
    santander_perk_4_bold: {
      en: 'Fixed',
      el: 'Σταθερό'
    },
    santander_perk_5: {
      en: '{bold} by connecting to gov.gr',
      el: '{bold} με σύνδεση στο gov.gr'
    },
    santander_perk_5_bold: {
      en: 'Instant identification',
      el: 'Άμεση ταυτοποίηση'
    },
    'fixed interest rate {amount}': {
      en: 'Fixed interest rate {amount}',
      el: 'Σταθερό επιτόκιο {amount}'
    },
    alpha_perk_1: {
      en: '{bold} for personal needs, wherever you are',
      el: '{bold} για προσωπικές ανάγκες, όπου κι αν βρίσκεσαι'
    },
    alpha_perk_1_bold: {
      en: 'Loan up to {max}€',
      el: 'Δάνειο έως {max}€'
    },
    alpha_perk_2: {
      en: '{bold} at Alpha Bank, {default}% otherwise',
      el: '{bold} σου στην Alpha Bank, διαφορετικά {default}%'
    },
    alpha_perk_2_bold: {
      en: 'Secure {salaried}% interest rate with salary or pension',
      el: 'Επιτόκιο {salaried}% με τη μισθοδοσία ή τη σύνταξή'
    },
    alpha_perk_3: {
      en: 'Apply {bold1} and {bold2}',
      el: 'Αίτηση {bold1} και {bold2}'
    },
    alpha_perk_3_bold_1: {
      en: 'in a flash',
      el: 'σε ελάχιστα λεπτά'
    },
    alpha_perk_3_bold_2: {
      en: 'without any   documents',
      el: 'χωρίς δικαιολογητικά'
    },
    alpha_perk_4: {
      en: '{bold}, 24/7',
      el: '{bold}, 24/7'
    },
    alpha_perk_4_bold: {
      en: 'Receive an instant response',
      el: 'Απάντηση αμέσως'
    },
    alpha_perk_5: {
      en: 'Have the money deposited into your account {bold}',
      el: 'Κατάθεση σε λογαριασμό σου {bold}'
    },
    alpha_perk_5_bold: {
      en: 'within 2 business days',
      el: 'μέσα σε 2 εργάσιμες μέρες'
    }
  })
})
